/* global axios */
import ApiClient from './ApiClient';

class SearchAPI extends ApiClient {
  constructor() {
    super('search', { accountScoped: true });
  }

  get({ q }) {
    return axios.get(this.url, {
      params: {
        q,
      },
    });
  }

  contacts(searchOptions) {
    return axios.get(`${this.url}/contacts`, {
      params: {
        ...searchOptions
      },
    });
  }

  conversations(searchOptions) {
    return axios.get(`${this.url}/conversations`, {
      params: {
        ...searchOptions
      },
    });
  }

  messages(searchOptions) {
    return axios.get(`${this.url}/messages`, {
      params: {
        ...searchOptions
      },
    });
  }
}

export default new SearchAPI();
